import { ShieldCheck, Target, Users } from "lucide-react";
import aboutImage from "@/images/site/about.jpg";
import Container from "../site/Container";
import CtaBand from "../site/CtaBand";
import FeatureStrip, { Feature } from "../site/FeatureStrip";
import PageHeader from "../site/PageHeader";

const values: Feature[] = [
  { icon: Users, title: "Australia-focused", text: "Designed for the Australian property market." },
  { icon: Target, title: "Aligned with buyers", text: "We succeed when you succeed." },
  { icon: ShieldCheck, title: "Responsible and transparent", text: "Clear terms and disciplined risk management." },
];

const About = () => {
  return (
    <>
      <section className="py-14 sm:py-20">
        <Container>
          <div className="relative">
            <div className="absolute inset-y-0 right-0 hidden overflow-hidden rounded-r-2xl lg:block lg:w-[46%] xl:w-[45%]">
              <img src={aboutImage} alt="" className="h-full w-full object-cover object-[center_40%]" />
              <div className="absolute inset-y-0 left-0 w-3/5 bg-linear-to-r from-white via-white/70 to-transparent" />
            </div>
            <PageHeader
              eyebrow="About OnHome"
              title={
                <>
                  Helping more Australians <br className="hidden xl:block" />
                  get into the homes they want.
                </>
              }
              className="relative max-w-2xl lg:py-8 xl:max-w-[49rem]"
            >
              <div className="max-w-xl space-y-4">
                <p>
                  OnHome was founded to solve one of Australia’s biggest challenges: the growing gap between what people
                  can afford and the homes they actually want.
                </p>
                <p>
                  Our BuySooner Boost product gives eligible home buyers a larger buying budget today, so they can
                  purchase sooner and build their wealth earlier, with a clear and transparent path to repay.
                </p>
                <p>
                  We work with trusted lending and property professionals and use disciplined risk management to create
                  a sustainable program.
                </p>
              </div>
            </PageHeader>
            <img src={aboutImage} alt="" className="mt-10 aspect-[4/3] w-full rounded-2xl object-cover lg:hidden" />
          </div>

          <FeatureStrip features={values} className="mt-12" />
        </Container>
      </section>

      <CtaBand />
    </>
  );
};

export default About;
